if (!customElements.get('videos-slider')) {
  class VideosSlider extends HTMLElement {
    selectors = {
      slider: '.swiper',
      slide: '.swiper .swiper-slide',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.settings = {
        slidesPerView: 'auto',
        loop: true,
        slideToClickedSlide: true,
        centeredSlides: true,
        navigation: {
          prevEl: this.querySelector('.slider__arrow.arrow-left'),
          nextEl: this.querySelector('.slider__arrow.arrow-right'),
        },
        on: {
          slideChange: function () {
            // Pause video in the previous slide
            const previousSlide = this.slides[this.previousIndex];
            const video = previousSlide.querySelector('video');

            if (!video) {
              return;
            }

            video.pause();

            if (video.currentTime > 0) {
              video.closest('.media')?.classList.add('paused');
            }

            video.closest('.media')?.classList.remove('play');
          },
        },
      };

      const slider = this.querySelector(this.selectors.slider);
      this.slider = new Swiper(slider, this.settings);

      // Attach Slide change event after user interaction to prevent video play error.
      this.addEventListener(
        'click',
        () => {
          this.slider.on('slideChange', this.handleSlideChange.bind(this));
        },
        { once: true, bubbles: true },
      );

      this.querySelectorAll(this.selectors.slide).forEach((slide) => {
        slide
          .querySelector('button')
          ?.addEventListener('click', this.handleVideoButtonClick.bind(this));
      });

      if (Shopify.designMode) {
        document.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect.bind(this),
        );
      }
    }

    /**
     * Handle Shopify admin section block select.
     * @param {Object} e Event
     */
    handleBlockSelect(e) {
      const targetIndex = Number(e.target?.getAttribute('data-slide-index'));

      if (!Number.isNaN(targetIndex)) {
        this.slider.slideToLoop(targetIndex);
      }
    }

    /**
     * Handle video play button click.
     *
     * @param {Object} e Event
     * @returns {Void}
     */
    handleVideoButtonClick(e) {
      const video = e.target
        .closest(this.selectors.slide)
        ?.querySelector('video');

      if (!video) {
        return;
      }

      if (video.paused) {
        this.playVideo(video);
        return;
      }

      this.pauseVideo(video);
    }

    /**
     * Play video.
     *
     * @param {HTMLElement} video
     * @returns {Void}
     */
    playVideo(video) {
      if (!video) {
        return;
      }
      const mediaContainer = video.closest('.media');

      video.play();
      mediaContainer?.classList.add('play');
      mediaContainer?.classList.add('is-playing');
      mediaContainer?.classList.remove('paused');
    }

    /**
     * Pause video.
     *
     * @param {HTMLElement} video
     * @returns {Void}
     */
    pauseVideo(video) {
      if (!video) {
        return;
      }
      const mediaContainer = video.closest('.media');

      video.pause();

      if (video.currentTime > 0) {
        mediaContainer?.classList.add('paused');
      }

      mediaContainer?.classList.remove('play');
    }

    /**
     * Handle slide change.
     *
     * @param {Object} e Event
     * @returns {Void}
     */
    handleSlideChange(e) {
      const slide = this.querySelector(
        `[data-swiper-slide-index="${e.realIndex}"]`,
      );

      if (!slide) {
        return;
      }

      this.playVideo(slide.querySelector('video'));
    }
  }

  customElements.define('videos-slider', VideosSlider);
}
